<template>
    <div class="w-full mt-6" v-if="$page.props.success || $page.props.error">
        <div class="notice-error pl-4 py-3 border-l-4 flex w-full rounded" v-if="$page.props.error">
            <RoundCross width="20" class="mr-3 mb-auto flex-shrink-0" />
            <div>
                <strong class="mb-1 block leading-tight">{{ $__($page.props.error[0]) }}</strong>
                <span>{{ $__($page.props.error[1]) }}</span>
            </div>
        </div>
        <div class="notice-success pl-4 py-3 border-l-4 flex w-full rounded" v-if="$page.props.success">
            <RoundCheck width="24" class="mr-3 mb-auto flex-shrink-0" />
            <div>
                <strong class="mb-1 block leading-tight">{{ $__($page.props.success[0]) }}</strong>
                <span>{{ $__($page.props.success[1]) }}</span>
            </div>
        </div>
    </div>
</template>
<script>
import RoundCross from "@/Components/Icons/RoundCross";
import RoundCheck from "@/Components/Icons/RoundCheck";
export default {
    components: {RoundCross, RoundCheck}
}
</script>
